<template>
	<transition name="fade-slide-up-enter">
		<div class="game-hints" v-html="hint.content" />
	</transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: 'GameHints',
	computed: {
		...mapGetters({
			hint: "game/hints/active",
		}),
	},
};
</script>

<style lang="scss" scoped>
	.game-hints {
		width: 300px;
		text-align: center;
		font-size: $font-size-lg;
		text-align: center;
	}
</style>
